// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + chunkId + "." + {"347":"1ed56769","667":"ab15d7cc","818":"fcaa35e6","974":"ee9b2fae"}[chunkId] + ".css";
};